var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPcFireSuppression(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00794 17.5313C-0.245117 14.5 1.09953 10.3134 2.54992 8.4507C4.15295 14.7373 8.04611 11.2447 6.21404 7.98503C4.18153 4.36872 7.13007 1 8.04611 1C8.04611 1 6.80946 3.74742 11.0232 7.28652C15.237 10.8256 13.7071 15.3748 12.1683 17.0656C10.8303 18.5357 6.48662 20.7728 3.00794 17.5313Z",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcFireSuppression);
export default __webpack_public_path__ + "static/media/pc-fire-suppression.09a74f394c597ec0d2d232d4f50a6c3a.svg";
export { ForwardRef as ReactComponent };